
import { useContactForm } from "@/hooks/useContactForm";
import ContactFormFields from "@/components/contact/ContactFormFields";
import FormStatusMessage from "@/components/contact/FormStatusMessage";

const ContactForm = () => {
  const { form, isSubmitting, submitStatus, onSubmit } = useContactForm();

  return (
    <>
      <ContactFormFields 
        form={form}
        isSubmitting={isSubmitting}
        onSubmit={onSubmit}
      />
      
      <FormStatusMessage status={submitStatus} />
    </>
  );
};

export default ContactForm;
